module.exports = __webpack_public_path__ + "img/server-location-icon.186436ef.svg";